<template>
  <v-dialog max-width="1000px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto;">
        <h2>Set zone</h2>
        <v-form ref="form_name" v-model="valid" lazy-validation>
          <v-text-field
            label="Zone name"
            :disabled="isEditTransfer"
            v-model="transfer_zone_form.transport_zone_name_th"
            hide-details
            :rules="[v => !!v || 'Item is required']"
          ></v-text-field>
          <v-textarea
            :disabled="isEditTransfer"
            label="Note"
            rows="2"
            v-model="transfer_zone_form.transport_zone_note"
            hide-details
          ></v-textarea>
        </v-form>
        <v-card color="secondary" class="mt-4">
          <v-card-text>
            <h2 v-if="!isEditTransfer">Set sub zone</h2>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap justify-space-around>
                <v-flex xs3 class="mr-2">
                  <v-select
                    @change="onChangeProvince($event)"
                    v-model="sub_zone_form.tzm_province_id"
                    :items="province_list"
                    item-text="province_name_th"
                    item-value="province_id"
                    label="Province"
                    :loading="fetch_province"
                    v-if="!isEditTransfer"
                  ></v-select>
                </v-flex>
                <v-flex xs3 class="mx-1">
                  <v-select
                    v-if="!isEditTransfer"
                    @change="onChangeDistrict($event)"
                    v-model="sub_zone_form.tzm_district_id"
                    :items="district_list"
                    item-text="district_name_th"
                    item-value="district_id"
                    label="District"
                    :loading="fetch_district"
                  ></v-select>
                </v-flex>
                <v-flex xs3 class="ml-2">
                  <v-select
                    v-if="!isEditTransfer"
                    v-model="sub_zone_form.tzm_sub_district_id"
                    :items="sub_district_list"
                    item-text="sub_district_name_th"
                    item-value="sub_district_id"
                    label="Sub district"
                    :loading="fetch_sub_district"
                  ></v-select>
                </v-flex>
                <v-flex xs2 class="text-xs-center">
                  <v-btn
                    v-if="!isEditTransfer"
                    color="primary"
                    class="black--text"
                    @click="addSubZone()"
                  >add</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
            <h4>Sub zone list in this zone</h4>
            <v-data-table
              :loading="fetch_transport_zone_sub_district"
              :headers="headers"
              :items="transfer_zone_form.transport_zone_sub_district"
              :pagination.sync="pagination"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ editedIndex == -1 ? null : props.item.tzm_id }}</td>
                <td class="text-xs-center">{{ props.item.tzm_sub_district_name }}</td>
                <td class="justify-center layout px-0">
                  <v-tooltip top>
                    <v-btn
                      :disabled="isEditTransfer"
                      icon
                      slot="activator"
                      @click="transfer_zone_form.transport_zone_sub_district.splice(props.index,1)"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                    <span>Delete</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data"></template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <span transition="fade">
          <v-icon color="green" v-if="update_loading == 2">check</v-icon>
          <v-icon color="red" v-if="update_loading == 3">close</v-icon>
          <v-progress-circular
            :width="3"
            :size="15"
            indeterminate
            color="grey"
            v-if="update_loading == 1"
          ></v-progress-circular>
          {{ update_loading == 1 ? 'Updating' : update_loading == 2 ? 'Update successfully' : update_loading == 3 ? 'Cant update' : null}}
        </span>
        <v-btn
          color="red"
          flat
          @click="$emit('setDialog', false) && $emit('setEditIndex',-1)"
          v-if="!isEditTransfer"
        >Cancel</v-btn>
        <v-btn color="green" flat @click="save()" v-if="!isEditTransfer">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "transfer_zone_form"],
  data() {
    return {
      update_loading: 0,
      fetch_transport_zone_sub_district: false,
      fetch_district: false,
      fetch_sub_district: false,
      fetch_province: false,
      pagination: {},
      valid: true,
      headers: [
        {
          text: "ID",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Sub zone name",
          align: "center",
          value: "role",
          sortable: false
        },
        {
          text: "Action",
          align: "center",
          value: "name",
          sortable: false
        }
      ],
      sub_zone_form: {}
    };
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue == true) {
        this.update_loading = 0;
        this.fetchAddress();
        this.$refs.form_name.resetValidation();
      }
    }
  },
  computed: {
    ...mapState({
      province_list: state => state.fetchProvinceBack.province_list,
      district_list: state => state.fetchProvinceBack.district_list,
      sub_district_list: state => state.fetchProvinceBack.sub_district_list
    }),
    ...mapGetters({
      isEditTransfer: "isEditTransfer"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Zone" : "Edit Zone";
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    validateSubZoneList() {
      if (this.transfer_zone_form.transport_zone_sub_district.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    async save() {
      if (this.$refs.form_name.validate() && this.validateSubZoneList()) {
        let obj1 = JSON.parse(JSON.stringify(this.transfer_zone_form));
        for (let val of obj1.transport_zone_sub_district) {
          delete val.tzm_sub_district_name;
        }
        if (this.editedIndex == -1) {
          this.$store.dispatch("fetchFoodZoneBack/addTransferZoneList", obj1);
          this.$emit("setDialog", false);
          this.$emit("setEditIndex", -1);
        } else {
          this.update_loading = 1;
          this.update_loading = await this.$store.dispatch(
            "fetchFoodZoneBack/editTransferZoneList",
            obj1
          );
        }
      } else {
        alert("กรุณาใส่โซนย่อย");
      }
    },
    validateSubzone() {
      if (
        Object.keys(this.sub_zone_form).length === 3 &&
        this.sub_zone_form.constructor === Object
      ) {
        return true;
      } else {
        return false;
      }
    },
    addSubZone() {
      if (this.validateSubzone()) {
        for (let val of this.sub_district_list) {
          if (val.sub_district_id == this.sub_zone_form.tzm_sub_district_id) {
            this.sub_zone_form.tzm_sub_district_name = val.sub_district_name_th;
          }
        }
        this.transfer_zone_form.transport_zone_sub_district.push(
          this.sub_zone_form
        );
        this.sub_zone_form = {};
      } else {
        alert("กรุณาเลือกจังหวัด, อำเภอ และ ตำบล ให้ครบถ้วน");
      }
    },
    async onChangeDistrict(district_id) {
      this.fetch_sub_district = true;
      await this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictList",
        district_id
      );
      this.fetch_sub_district = false;
    },
    async onChangeProvince(province_id) {
      this.fetch_district = true;
      await this.$store.dispatch(
        "fetchProvinceBack/getDistrictList",
        province_id
      );
      this.fetch_district = false;
    },
    async fetchAddress() {
      this.fetch_province = true;
      await this.$store.dispatch("fetchProvinceBack/getProvinceList");
      this.fetch_province = false;
    },
    initialize() {}
  }
};
</script>
<style>
.transfer-title {
  font-size: 20px;
  padding-bottom: 10px;
}
</style>




